const TOAST_EVENT = 'savel:toast';
const TOAST_DISMISS_EVENT = 'savel:toast-dismiss';

let nextToastId = 1;

const emit = (type, message, options = {}) => {
  if (!message || typeof window === 'undefined') return null;

  const id = nextToastId++;
  window.dispatchEvent(new CustomEvent(TOAST_EVENT, {
    detail: {
      id,
      type,
      message: String(message),
      duration: options.autoClose === false
        ? 0
        : Number(options.autoClose || options.duration || 3200),
    },
  }));
  return id;
};

export const toast = {
  success: (message, options) => emit('success', message, options),
  error: (message, options) => emit('error', message, { autoClose: 4800, ...options }),
  info: (message, options) => emit('info', message, options),
  warning: (message, options) => emit('warning', message, { autoClose: 4200, ...options }),
  dismiss: (id = null) => {
    if (typeof window === 'undefined') return;
    window.dispatchEvent(new CustomEvent(TOAST_DISMISS_EVENT, { detail: { id } }));
  },
};

export { TOAST_EVENT, TOAST_DISMISS_EVENT };
